/* eslint-disable import/no-named-as-default */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Parser from "html-react-parser";
import EditButton from "../shared/button/EditButton";
import WidgetLoading from "../shared/loaders/WidgetLoading";
import AboutCompanyEdit from "./EditForms/AboutCompanyEdit"; // eslint-disable-line import/no-named-as-default
import {
  Wrapper,
  Body,
  ReadMore,
  ReadMoreButton,
} from "./styles/about-company-styles";

export class AboutCompany extends Component {
  state = {
    editAboutCompanyActive: false,
  };

  toggleEditAboutCompany = () => {
    this.setState(({ editAboutCompanyActive }) => ({
      editAboutCompanyActive: !editAboutCompanyActive,
    }));
  };

  render() {
    const {
      about,
      user,
      currentUser,
      aboutCompanyFormLoading,
      toggleAboutCompanyModal,
    } = this.props;
    const { editAboutCompanyActive } = this.state;
    const defaultText = currentUser.isRecruiter
      ? "Please add your information here"
      : "We're working on building our profile right now";

    return (
      <Wrapper>
        {aboutCompanyFormLoading && <WidgetLoading />}
        {editAboutCompanyActive && (
          <AboutCompanyEdit
            toggleEditAboutCompany={this.toggleEditAboutCompany}
          />
        )}
        {user.isAdmin && currentUser.isRecruiter && (
          <EditButton
            onClickAction={this.toggleEditAboutCompany}
            top={8}
            right={10}
          />
        )}
        {about && about.length > 0 ? (
          <Body>{Parser(about)}</Body>
        ) : (
          <Body data-test-id="default-about-company" noData>
            {defaultText}
          </Body>
        )}
        {about && about.length > 500 && (
          <ReadMore>
            <ReadMoreButton
              data-test-id="company-read-more-button"
              onClick={() => toggleAboutCompanyModal()}
            >
              read more
            </ReadMoreButton>
          </ReadMore>
        )}
      </Wrapper>
    );
  }
}

AboutCompany.propTypes = {
  about: PropTypes.string,
  user: PropTypes.shape({
    isRecruiter: PropTypes.bool.isRequired,
    isAdmin: PropTypes.bool.isRequired,
  }).isRequired,
  currentUser: PropTypes.shape({
    isRecruiter: PropTypes.bool.isRequired,
  }).isRequired,
  aboutCompanyFormLoading: PropTypes.bool.isRequired,
  toggleAboutCompanyModal: PropTypes.func.isRequired,
};

AboutCompany.defaultProps = {
  about: PropTypes.isNull,
};

const mapStateToProps = (state) => ({
  about: state.agencyProfile.profileData.aboutCompany,
  user: state.agencyProfile.profileData.user,
  currentUser: state.agencyProfile.profileData.currentUser,
  aboutCompanyFormLoading: state.agencyProfile.aboutCompanyFormLoading,
});

export default connect(mapStateToProps, {})(AboutCompany);
